import z from "zod";
import { dayUnits } from "../../units";

export const projectSettingsFormSchema = z.object({
	invoicingPeriodValue: z.number().min(0),
	invoicingPeriodUnit: z.enum(dayUnits),
});

export type ProjectSettingsFormSchema = z.infer<typeof projectSettingsFormSchema>;
